'use client';

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useState } from 'react';
import { toPathname } from '../../personly-libs-pathnames/src/index.js';
import { useLocalizedPathname } from '../../personly-libs-hooks/src/index.js';
export { MenusProvider, useMenus };
const MenusContext = createContext(null);
const MenusProvider = t0 => {
  const $ = _c(17);
  const {
    children,
    locales,
    menu,
    initialOpen: t1
  } = t0;
  const initialOpen = t1 === undefined ? false : t1;
  const [isOpen, setIsOpen] = useState(initialOpen);
  const localizedPathname = useLocalizedPathname(locales);
  let t2;
  if ($[0] !== localizedPathname || $[1] !== menu) {
    t2 = pathname => menu.find(t3 => {
      const {
        slug
      } = t3;
      const currentPathname = localizedPathname(toPathname(slug));
      const regexPathname = currentPathname.replaceAll("/", "\\/");
      const regex = new RegExp(`^${regexPathname}(\\/.*)?$`);
      return regex.test(pathname);
    });
    $[0] = localizedPathname;
    $[1] = menu;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const matchEntry = t2;
  let t3;
  if ($[3] !== localizedPathname) {
    t3 = (t4, active) => {
      const {
        slug: slug_0,
        groupHandle,
        title
      } = t4;
      const href = localizedPathname(toPathname(slug_0));
      return {
        active,
        groupHandle,
        href,
        title
      };
    };
    $[3] = localizedPathname;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const makeRoute = t3;
  let t4;
  if ($[5] !== makeRoute || $[6] !== matchEntry || $[7] !== menu) {
    t4 = pathname_0 => {
      const matchedEntry = matchEntry(pathname_0);
      return menu.filter(t5 => {
        const {
          groupHandle: groupHandle_0
        } = t5;
        return matchedEntry ? groupHandle_0 === matchedEntry.groupHandle : true;
      }).reduce((acc, menuEntry) => {
        if (!matchedEntry) {
          const i = acc.findIndex(t6 => {
            const {
              groupHandle: groupHandle_1
            } = t6;
            return groupHandle_1 === menuEntry.groupHandle;
          });
          if (i === -1 && !menuEntry.slug.includes("/")) {
            acc.push(makeRoute(menuEntry, false));
          }
          return acc;
        }
        if (menuEntry.slug.includes("/")) {
          return acc;
        }
        const active_0 = matchedEntry.slug === menuEntry.slug;
        const route = makeRoute(menuEntry, active_0);
        return [...acc, route];
      }, []).sort(sortRoutes);
    };
    $[5] = makeRoute;
    $[6] = matchEntry;
    $[7] = menu;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const routes = t4;
  let t5;
  if ($[9] !== isOpen) {
    t5 = () => {
      setIsOpen(!isOpen);
    };
    $[9] = isOpen;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const toggle = t5;
  let t6;
  if ($[11] !== children || $[12] !== isOpen || $[13] !== matchEntry || $[14] !== routes || $[15] !== toggle) {
    const value = {
      toggle,
      isOpen,
      routes,
      matchEntry
    };
    t6 = _jsx(MenusContext.Provider, {
      value,
      children
    });
    $[11] = children;
    $[12] = isOpen;
    $[13] = matchEntry;
    $[14] = routes;
    $[15] = toggle;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
function useMenus() {
  const context = useContext(MenusContext);
  if (!context) {
    throw new Error("useMenus requires a context!");
  }
  return context;
}
/**
 * Sort routes by title so that they are displayed alphabetically.
 *
 * @param {Route} lhs A route to compare for sorting
 * @param {Route} rhs A route to compare for sorting
 * @return An integer value corresponding to the new position of the route
 */
export const sortRoutes = (lhs, rhs) => {
  if (lhs.title > rhs.title) return 1;
  if (lhs.title < rhs.title) return -1;
  return 0;
};